// @flow

import React from 'react';
import { connect } from 'react-redux';
import NewsPreview from './newsPreview';
import { getNewsItems } from '../../../store/news';
import { getNewsReadMoreLabel } from '../../../store/newsSettings';
import type { NewsItem } from '../../../types';
import { ColumnBox as Column } from '../../column';

type StateProps = {|
  items: ?Array<NewsItem>,
  readMoreLabel: string,
|};

const NewsPreviewGrid = ({ items, readMoreLabel }: StateProps) => (
  <>
    { items && items.map(item => (
      <Column
        key={item.title}
        componentsOverCut={false}
        slidersEnabled={false}
        image={null}
      >
        <NewsPreview
          highlight={false}
          key={item.title}
          readMoreLabel={readMoreLabel}
          {...item}
        />
      </Column>
    ))}
  </>
);

const mapStateToProps = (state): StateProps => ({
  items: getNewsItems(state, 1),
  readMoreLabel: getNewsReadMoreLabel(state),
});

export default connect<any, any, StateProps, any, any, any>(mapStateToProps)(NewsPreviewGrid);
